import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import eyeIconImage from '../assets/svgs/eyeicon.svg';
import '../components-css/single-blog-page.scss';
import Loader from '../components/loader';
import axios from 'axios';

const SingleBlogPage = () => {

  const [singleBlogData, setSingleBlogData] = useState({});
  const [loading, setLoading] = useState(true);
  const [views, setViews] = useState(0);   // ✅ ADD VIEW STATE

  const { id } = useParams();

  // ------------------ FETCH BLOG ------------------
  useEffect(() => {
    const getBlogById = async () => {
      try {
        const payload = { slug: id };
        const response = await axios.post(
          'https://newomkatech.omkatech.in/api/GetBlogdetails',
          payload
        );
        setSingleBlogData(response.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    getBlogById();
  }, [id]);

  // ------------------ SESSION BASED VIEW COUNT ------------------
  useEffect(() => {
    if (!id) return;

    const sessionKey = `blog_view_${id}`;

    if (!sessionStorage.getItem(sessionKey)) {
      sessionStorage.setItem(sessionKey, 'true');
      setViews(1);
    } else {
      setViews(1); // already counted for this session
    }
  }, [id]);

  // ------------------ DATE FORMAT ------------------
  function formatDate(isoString) {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  const formattedDate = formatDate(singleBlogData?.created_at);

  return (
    <div className='single-blog-page-container'>
      {loading ? (
        <Loader />
      ) : (
        <>
          <h1>{singleBlogData?.title}</h1>
          <span className='time'>{singleBlogData?.minute_read}-MINUTE READ</span>
          <span className='date'>{formattedDate}</span>

          <div className="image">
            <img
              src={singleBlogData?.file_path + singleBlogData?.image}
              alt="blog-icon"
            />
          </div>

          <p dangerouslySetInnerHTML={{ __html: singleBlogData?.description }} />

          <div className='writer-info'>
            <div className='views'>
              <img src={eyeIconImage} alt="icon-image" />
              <p>{views} View</p>
            </div>

            <div className='writer'>
              <p>WRITTEN BY :</p>
              <span>{singleBlogData?.written_by}</span>
              <p>{singleBlogData?.designation}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SingleBlogPage;
